import type { RouteRecordRaw } from 'vue-router';
import { settingRoute } from '@/pages/setting/route';

export const settingRoutes: RouteRecordRaw = {
    path: '/setting',
    component: () => import('@/layouts/main.vue'),
    children: [
        settingRoute(),
    ],
}; 